import React from 'react';

import Notifications from '../bb-notifications';
import BbUpdateHeader from '../bb-update-header';
import HeaderItemsMain from './header__items--main';

import { If, Then } from '../../components/IfElse';

const CHeader = ({ minimal }) => (
	<div className="c-header">
		<If condition={!minimal}>
			<Then>
				<BbUpdateHeader />
				<Notifications />
			</Then>
		</If>
		<HeaderItemsMain minimal={minimal} />
	</div>
);

export default CHeader;
